"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const Catering_1 = __importDefault(require("./Catering"));
const WidgetButton_1 = __importDefault(require("./formControls/WidgetButton"));
function startTime(props) {
    const [selectedStartTime, setSelectedStartTime] = (0, react_1.useState)(null);
    const [startTimeData, setStartTimeData] = (0, react_1.useState)(null);
    const [firstRender, setFirstRender] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        getStartTimeData();
    }, [props]);
    const getStartTimeData = () => {
        const params = new URLSearchParams();
        params.append("selectedDate", props.selectedDate);
        params.append("paxCount", props.paxCount.toString());
        params.append("duration", props.duration.toString());
        const baseUrl = "/api/widget/startTime/" + props.uuid;
        axios_1.default
            .get(baseUrl, {
            params: params,
        })
            .then((response) => {
            if (selectedStartTime !== null) {
                let found = false;
                response.data.timeslots.forEach((timeslot) => {
                    if (timeslot.value === selectedStartTime) {
                        found = true;
                    }
                });
                if (!found) {
                    setSelectedStartTime(null);
                }
            }
            setStartTimeData(response.data);
            if (firstRender) {
                setTimeout(() => {
                    var _a;
                    (_a = document.getElementById(props.parentElementId)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: "smooth" });
                    setFirstRender(false);
                }, 500);
            }
        })
            .catch((error) => {
            console.log(error);
        });
    };
    const handleStartTimeChange = (startTime) => {
        setSelectedStartTime(startTime);
    };
    return (react_1.default.createElement("div", { id: "startTime" },
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 4 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Typography, { variant: "h4" }, "Start Time")),
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.Grid, { container: true, width: "100%" },
                        startTimeData && !(startTimeData === null || startTimeData === void 0 ? void 0 : startTimeData.timeslots.length) && react_1.default.createElement(material_1.Typography, null, "The combination of date and duration you have chosen is unavailable. Please select a different option to book."), startTimeData === null || startTimeData === void 0 ? void 0 :
                        startTimeData.timeslots.map((timeslot) => (react_1.default.createElement(material_1.Grid, { item: true, xs: 4, key: timeslot.value },
                            react_1.default.createElement(WidgetButton_1.default, { onClick: () => handleStartTimeChange(timeslot.value), selected: timeslot.value === selectedStartTime },
                                react_1.default.createElement(material_1.Stack, null,
                                    react_1.default.createElement(material_1.Typography, { variant: "body1" },
                                        react_1.default.createElement("strong", null, timeslot.labelStart)),
                                    react_1.default.createElement(material_1.Typography, { variant: "body2" },
                                        "to ",
                                        timeslot.labelEnd))))))))),
            selectedStartTime && (react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(Catering_1.default, { uuid: props.uuid, brandId: props.brandId, selectedDate: props.selectedDate, paxCount: props.paxCount, duration: props.duration, selectedTime: selectedStartTime, parentElementId: "startTime" }))))));
}
exports.default = startTime;
